<div class="row">
  <div class="col-12 m-t-lg">
    <p>{{authContent.pageHeading}}</p>
  </div>
  <div class="col-12 m-t-xs p-l-lg m-l-xl">
    <ul class="bulleted-list">
      <li *ngFor="let bulletData of bulletPoints; " class="p">{{bulletData}}</li>
    </ul>
  </div>
</div>
